export function removeNonConfigFields(full_workflow) {
  const template_to_download = { ...full_workflow };
  delete template_to_download.StartTimeStamp
  delete template_to_download.WorkflowStatus
  delete template_to_download.LastExecutionGUID
  delete template_to_download.Teardown
  delete template_to_download.Archived
  delete template_to_download.LastExecutionTime
  delete template_to_download.LastModified
  delete template_to_download.NotificationTopicARN
  delete template_to_download.Subscribers
  delete template_to_download.Versions;
  ['DeploymentRecipe', 'TestFunctions'].forEach((section) => {
    template_to_download[section].forEach((template, index) => {
      Object.keys(template).forEach((key) => {
        if (template[key] === undefined) {
          delete template_to_download[section][index][key]
        }
      });
    })
  })
  return template_to_download;
}

export function removeEmptyFields(obj: any) {
  if (obj.DefaultParameterSet && !obj.DefaultParameterSet.Name && !obj.DefaultParameterSet.Version) {
    delete obj.DefaultParameterSet;
  }

  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') {
      removeEmptyFields(obj[key]);
    } else if (obj[key] === '') {
      delete obj[key];
    }
  });
};

export function buildEmptyWorkflow(familyId: string, userId: string) {
  return {
    "CustomTags": [],
    "Region": "",
    "Approvers": {
      "PreApprovers": []
    },
    "TestFunctions": [],
    "AccountName": "",
    "Archived": false,
    "DisableTeardown": false,
    "EnableScheduledTests": false,
    "WorkflowAccess": {
      "WorkflowRunners": [],
      "AllowedARNs": [],
      "WorkflowEditors": [],
      "WorkflowOwner": userId
    },
    "DeploymentRecipe": [],
    "Notifiers": [userId],
    "DefaultDeploymentIAMRole": "",
    "Teardown": true,
    "Name": "",
    "Family": familyId
  };
}
